
import React, { useState } from 'react';
import { Col, Container, Row, Tab, Tabs, InputGroup, FormControl, Card, Nav, Button, Form, Spinner, Table } from "react-bootstrap";

export function CountryTranslateFormTabTravel(props) {

    const [data, setData] = useState(props.data);
    const set = {};

    [data.tourist_information, set.tourist_information] = useState(props.data.tourist_information || '');
    [data.text_entry_exit_requirements[props.primary_language_id], set.primary_text_entry_exit_requirements] = useState(props.data.text_entry_exit_requirements[props.primary_language_id] || '');
    [data.text_immunization_requirements[props.primary_language_id], set.primary_text_immunization_requirements] = useState(props.data.text_immunization_requirements[props.primary_language_id] || '');
    [data.text_additional_risks[props.primary_language_id], set.primary_text_additional_risks] = useState(props.data.text_additional_risks[props.primary_language_id] || '');
    [data.text_climate[props.primary_language_id], set.primary_text_climate] = useState(props.data.text_climate[props.primary_language_id] || '');
    [data.text_travel_time[props.primary_language_id], set.primary_text_travel_time] = useState(props.data.text_travel_time[props.primary_language_id] || '');

    [data.text_entry_exit_requirements[props.translate_language_id], set.translate_text_entry_exit_requirements] = useState(props.data.text_entry_exit_requirements[props.translate_language_id] || '');
    [data.text_immunization_requirements[props.translate_language_id], set.translate_text_immunization_requirements] = useState(props.data.text_immunization_requirements[props.translate_language_id] || '');
    [data.text_additional_risks[props.translate_language_id], set.translate_text_additional_risks] = useState(props.data.text_additional_risks[props.translate_language_id] || '');
    [data.text_climate[props.translate_language_id], set.translate_text_climate] = useState(props.data.text_climate[props.translate_language_id] || '');
    [data.text_travel_time[props.translate_language_id], set.translate_text_travel_time] = useState(props.data.text_travel_time[props.translate_language_id] || '');

    return (
        <Card body>
            <Row>
                <Col md="2">Entry/Exit requirements :</Col>
                <Col md="4"><Form.Group controlId="primary_travel_text_entry_exit_requirements">
                    <Form.Control type="text" as="textarea"
                        value={data.text_entry_exit_requirements[props.primary_language_id]}
                        onChange={e=>set.primary_text_entry_exit_requirements(e.target.value)}
                    />
                </Form.Group></Col>
                <Col md="5"><Form.Group controlId="translate_travel_text_entry_exit_requirements">
                    <Form.Control type="text" as="textarea"
                        value={data.text_entry_exit_requirements[props.translate_language_id]}
                        onChange={e=>set.translate_text_entry_exit_requirements(e.target.value)}
                    />
                </Form.Group></Col>
            </Row>
            <Row>
                <Col md="2">Immunization requirements :</Col>
                <Col md="4"><Form.Group controlId="primary_travel_text_immunization_requirements">
                    <Form.Control type="text" as="textarea"
                        value={data.text_immunization_requirements[props.primary_language_id]}
                        onChange={e=>set.primary_text_immunization_requirements(e.target.value)}
                    />
                </Form.Group></Col>
                <Col md="5"><Form.Group controlId="translate_travel_text_immunization_requirements">
                    <Form.Control type="text" as="textarea"
                        value={data.text_immunization_requirements[props.translate_language_id]}
                        onChange={e=>set.translate_text_immunization_requirements(e.target.value)}
                    />
                </Form.Group></Col>
            </Row>
            <Row>
                <Col md="2">Additional risks :</Col>
                <Col md="4"><Form.Group controlId="primary_travel_text_additional_risks">
                    <Form.Control type="text" as="textarea"
                        value={data.text_additional_risks[props.primary_language_id]}
                        onChange={e=>set.primary_text_additional_risks(e.target.value)}
                    />
                </Form.Group></Col>
                <Col md="5"><Form.Group controlId="translate_travel_text_additional_risks">
                    <Form.Control type="text" as="textarea"
                        value={data.text_additional_risks[props.translate_language_id]}
                        onChange={e=>set.translate_text_additional_risks(e.target.value)}
                    />
                </Form.Group></Col>
            </Row>
            <Row>
                <Col md="2">Climate :</Col>
                <Col md="4"><Form.Group controlId="primary_travel_text_climate">
                    <Form.Control type="text" as="textarea"
                        value={data.text_climate[props.primary_language_id]}
                        onChange={e=>set.primary_text_climate(e.target.value)}
                    />
                </Form.Group></Col>
                <Col md="5"><Form.Group controlId="translate_travel_text_climate">
                    <Form.Control type="text" as="textarea"
                        value={data.text_climate[props.translate_language_id]}
                        onChange={e=>set.translate_text_climate(e.target.value)}
                    />
                </Form.Group></Col>
            </Row>
            <Row>
                <Col md="2">Travel time :</Col>
                <Col md="4"><Form.Group controlId="primary_travel_text_travel_time">
                    <Form.Control type="text"
                        value={data.text_travel_time[props.primary_language_id]}
                        onChange={e=>set.primary_text_travel_time(e.target.value)}
                    />
                </Form.Group></Col>
                <Col md="5"><Form.Group controlId="translate_travel_text_travel_time">
                    <Form.Control type="text"
                        value={data.text_travel_time[props.translate_language_id]}
                        onChange={e=>set.translate_text_travel_time(e.target.value)}
                    />
                </Form.Group></Col>
            </Row>
            <Row>
                <Col md="2">Tourist Information :</Col>
                <Col md="4"><Form.Group controlId="primary_travel_tourist_information">
                    <Form.Control type="text"
                        value={data.tourist_information}
                        onChange={e=>set.tourist_information(e.target.value)}
                    />
                </Form.Group></Col>
            </Row>
        </Card>
    );
}
